class ScrollStory {
  constructor(el) {
    this.el = el;
    this.images = Array.from(el.querySelectorAll('[data-scroll-story-image]'));
    this.texts = Array.from(el.querySelectorAll('[data-scroll-story-text]'));
    this.dots = Array.from(el.querySelectorAll('[data-scroll-story-dot]'));
    this.count = this.texts.length;
    this.activeIndex = 0;

    this.onScroll = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onScroll, { passive: true });
    this.onScroll();
  }

  onScroll() {
    if (this.count <= 1) return;

    const rect = this.el.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    const totalScroll = rect.height - viewportHeight;
    let progress = totalScroll > 0 ? -rect.top / totalScroll : 0;
    progress = Math.min(1, Math.max(0, progress));

    let index = Math.floor(progress * this.count);
    if (index >= this.count) index = this.count - 1;
    if (index < 0) index = 0;

    if (index !== this.activeIndex) {
      this.activeIndex = index;
      this.images.forEach((el, i) => el.classList.toggle('is-active', i === index));
      this.texts.forEach((el, i) => el.classList.toggle('is-active', i === index));
      this.dots.forEach((el, i) => el.classList.toggle('is-active', i === index));
    }
  }
}

document.querySelectorAll('.scroll-story').forEach((el) => new ScrollStory(el));
